module.exports = __webpack_public_path__ + "img/wiperx_02.b0e32696.jpg";